import { createSelector } from 'reselect';

import modalTypes from '../../enums/modalTypes';

export const getOpenModalType = (state) => state.modal.type;

export const isDrawerModalOpen = createSelector(
  getOpenModalType,
  (type) => type === modalTypes.RIGHT_DRAWER
);

export const getOpenModalRef = (state) => state.modal.ref;

export const getModalsRef = (state) => state.modal.modalsRef;
